import { render, staticRenderFns } from "./TopSocialAdCreatives.vue?vue&type=template&id=c90445f8"
import script from "./TopSocialAdCreatives.vue?vue&type=script&lang=js"
export * from "./TopSocialAdCreatives.vue?vue&type=script&lang=js"
import style0 from "./TopSocialAdCreatives.vue?vue&type=style&index=0&id=c90445f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports